module.exports = "<article class=\"ui-article\"\r\n    max-width=\"lg\">\r\n  <nominas-cargacontpaq-importar\r\n      ng-if=\"$ctrl.idNomina && !$ctrl.data\"\r\n      on-close=\"$ctrl.calcular($event.data)\"></nominas-cargacontpaq-importar>\r\n  <nominas-cargacontpaq-calcular\r\n      ng-if=\"$ctrl.idNomina && $ctrl.data\"\r\n      id-proyecto=\"$ctrl.idProyecto\"\r\n      id-nomina=\"$ctrl.idNomina\"\r\n      data=\"$ctrl.data\"\r\n      on-close=\"$ctrl.aceptar($event.data)\"></nominas-cargacontpaq-calcular>\r\n</article>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/cargacontpaq/components/template.html
// module id = 823
// module chunks = 0